




















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Step } from '@/interfaces/Step';
import { Phase } from '@/interfaces/Phase';
import LanguageTextInput from '@/components/App/LanguageTextInput.vue';
import { Type } from '@/interfaces/Type';

@Component({
  components: { LanguageTextInput }
})
export default class ModuleStepListStepDefaultTab extends Vue {
  @Prop()
  restrictedUser!: boolean;

  @Prop()
  step!: Step;

  @Prop()
  defaultStep!: Step;

  @Prop()
  environmentSpecific!: number;

  get allPhases() {
    return this.$store.state.all_phases.map((phase: Phase) => {
      const obj = { value: phase.id, text: '' };
      const preferredLanguage =
        phase?.phaseLanguages.find(
          (sL: any) => sL.langaugeId === this.$store.state.user.languageId
        ) || phase?.phaseLanguages?.[0];
      obj.text = preferredLanguage?.name || '';
      return obj;
    });
  }

  get allTypes() {
    return this.$store.state.all_types.map((type: Type) => {
      const obj = { value: type.id, text: '' };
      const preferredLanguage =
        type?.typeLanguages.find(
          (sL: any) => sL.langaugeId === this.$store.state.user.languageId
        ) || type?.typeLanguages?.[0];
      obj.text = preferredLanguage?.name || '';
      return obj;
    });
  }

  get stepPhasePlaceholder() {
    const phase = this.$store.state.all_phases.find(
      (p: Phase) => p.id === this.defaultStep?.phase_id
    );
    if (phase?.name) return phase.name;
    return '';
  }

  get stepTypePlaceholder() {
    const type = this.$store.state.all_types.find((t: any) => t.id === this.defaultStep?.type_id);
    if (type?.name) return type.name;
    return '';
  }
}
